module.exports = __webpack_public_path__ + "static/img/nisekebae_ka.48e9f3d.jpg";